import React from 'react';

import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react';
import mixpanel from 'mixpanel-browser';
import { MixpanelProvider, MixpanelConsumer } from 'react-mixpanel';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import './styles/Index.css';
import Amplify from 'aws-amplify';

import pjson from '../package.json';

import App from './App';
import { getConfig } from './config';
import { store } from './store';

const config = getConfig();
Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
  },
  API: {
    endpoints: [
      {
        name: 'party',
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION,
        custom_header: async () => ({
          Authorization: (await Amplify.Auth.currentSession()).idToken.jwtToken,
        }),
      },
    ],
  },
});

const history = createBrowserHistory();

const mixPanelToken = config.mixpanelToken;
mixpanel.init(mixPanelToken);

Sentry.init({
  dsn:
    'https://11270f767ba94103a4cbfac1e645b4eb@o562516.ingest.sentry.io/5817670',
  environment: config.env,
  release: `bat-app@${pjson.version}`,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
    }),
  ],
  tracesSampleRate: 1.0,
});

const gb = new GrowthBook({
  ...config.growthBook,
});
gb.init({ streaming: true });

/* eslint-disable */
ReactDOM.render(
  <GrowthBookProvider growthbook={gb}>
    <MixpanelProvider mixpanel={mixpanel}>
      <Provider store={store}>
        <Router history={history}>
          <MixpanelConsumer>
            {mixpanel => (
              <App shopifyLinks={config.shopifyLinks} mixpanel={mixpanel} />
            )}
          </MixpanelConsumer>
        </Router>
      </Provider>
    </MixpanelProvider>
  </GrowthBookProvider>,
  document.getElementById('root')
);
